

import React, { useEffect, useState } from 'react';
import { FaQuoteRight } from "react-icons/fa";
import useApiCallHooks from '../../../hooks/useApiCallHooks';

const Testimonial = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [testimonials, setTestimonials] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    callAPI('get', 'home-page-data');
  }, []);

  useEffect(() => {
    if (statusCode === 200 && responce?.data?.testimonials) {
      setTestimonials(responce.data.testimonials);
    }
  }, [statusCode, responce]);

  const handlePrev = () => {
    if (currentSlide > 0) setCurrentSlide(currentSlide - 1);
  };

  const handleNext = () => {
    if (currentSlide < testimonials.length - 3) setCurrentSlide(currentSlide + 1);
  };

  return (
    <section className="py-5 bg-light">
      <div className="container text-center mb-4 ">
        <span className="badge rounded-pill bg-primary fs-6 px-4 py-2">Our Testimonials</span>
        <h2 className="fw-bold display-5 mt-3">What Our Students Say</h2>
      </div>

      {/* Navigation Buttons */}
      <div className="d-flex justify-content-between align-items-center px-4 mb-3">
        <button onClick={handlePrev} className="btn btn-primary px-4">←</button>
        <button onClick={handleNext} className="btn btn-primary px-4">→</button>
      </div>

      <div className="container">
        <div className="row g-4">
          {testimonials.slice(currentSlide, currentSlide + 3).map((item, index) => (
            <div className="col-md-4" key={item.id || index}>
              <div className="bg-white p-4 rounded  h-100  " style={{ boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)' }}>
                <img
                  src={item.company_logo}
                  alt="Company Logo"
                  style={{ height: "60px",width:"100px", objectFit: "contain" }}
                  className="mb-3"
                />
              <p className="text-muted fs-6">
  {item.description.split(' ').slice(0, 20).join(' ')}{item.description.split(' ').length > 20 && '...'}
</p>

                <FaQuoteRight
                  className="position-absolute text-secondary"
                  style={{ top: "20px", right: "20px", fontSize: "2rem", opacity: 0.2 }}
                />
                <div className="d-flex align-items-center mt-4">
                  <img
                    src={item.profile_pic}
                    alt="Profile"
                    className="rounded-circle me-3"
                    width="75"
                    height="75"
                  />
                  <div className="text-start">
                    <h6 className="mb-0 fw-bold">{item.name}</h6>
                    <small className="text-muted">{item.job_role}</small>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonial;

